// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".k-booking-card-base__notification[data-v-1b6bf25c]{padding:0 9px!important;height:18px!important}", ""]);
// Exports
module.exports = exports;
